import React from 'react';

const CMContent = ({ t }) => {
  return (
    <>
      <p>{t("cm.p1")}</p>
      <p>{t("cm.p2")}</p>
      <p>{t("cm.p3")}</p>
    </>
  );
};

const CM = ({ t, changeWord }) => {
  return (
    <div className="content-ac cm hide">
      <input
        className="ac-input top"
        id="ac-11afd"
        name="ac-11afd"
        data-id="2400"
        data-slug="CM"
        type="checkbox"
        onChange={() => changeWord('CM')}
      />
      <label className="ac-label" htmlFor="ac-11afd">{t("cm.label")}</label>
      <article className="ac-text ac-11afd">
        <div className="single-post-interior" tabIndex="0">
          <CMContent t={t} />
        </div>
        <footer></footer>
      </article>
    </div>
  );
};

export default CM;
